const doc = [({"en":({"js":({"components":({"users":({"circle_color_select":({"pink":"Pink", "orange":"Orange", "teal":"Turquoise", "purple":"Purple"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;